<template>
  <div :class="{'has-logo':showLogo}" class="menu">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper" :style="{width: isCollapse? '54px' : '308px'}">
      <div class="topTitle" :style="{justifyContent: isCollapse? 'flex-end' : 'space-between'}">
        <span class="title" v-if="!isCollapse">明珠绿环回收
        </span>
        <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

      </div>
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="variables.menuBg" :text-color="variables.menuText" :unique-opened="false" :active-text-color="variables.menuActiveText" :collapse-transition="false" mode="vertical">
        <sidebar-item :routes="routes" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import Hamburger from '@/components/Hamburger'
export default {
  components: { SidebarItem, Logo, Hamburger },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
  },
  data() {
    return {

    }
  },
  created() {
    // console.log(this.routes, "???")
  }
}
</script>
<style lang="scss">
.topTitle {
  background: rgba(0, 142, 100, -18.8);
  height: 74px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // text-align: center;
  // line-height: 108px;
  padding: 27px 5px 27px 52px;
  .title {
    color: #fff;
    font-size: 25px;
    font-weight: 500;
  }
  .hamburger-container {
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
}
.menu {
  .el-menu {
    .el-menu-item {
      font-size: 14px;
    }
    .el-menu-item.is-active {
      background: #15ad7d !important;
      font-size: 17px !important;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue